import React from 'react';
import styles from './TableContent.module.scss';
import { XPagination, XTableHOC } from '@/components/xqxc_ui';
import { Table } from 'antd';
import moment from 'moment';
import PropTypes from 'prop-types';
import { regFenToYuan } from '@/util/money';
import { tooltipStyle, tooltip, tooltipClick } from '@/components/TableCell';
import ButtonPerssion from '@/routes/ButtonPerssion';

class OrderTable extends React.Component {
    _takeColumns = () => ([
        {
            title: '罚单编号',
            dataIndex: 'id',
            key: 'id',
            width: '10%',
            align: 'center',
            onCell: tooltipStyle,
            render: (text, record) => tooltipClick(text, () => {
                this.props.tableAction(record.id, 'info', record);
            })
        },
        {
            title: '关联配送单号',
            dataIndex: 'deliveryId',
            key: 'deliveryId',
            width: '10%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '手机号码',
            dataIndex: 'riderTel',
            key: 'riderTel',
            width: '10%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '骑士',
            dataIndex: 'riderName',
            key: 'riderName',
            width: '10%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '状态',
            dataIndex: 'punishmentStateName',
            key: 'punishmentStateName',
            width: '10%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '处理结果',
            dataIndex: 'appealStateName',
            key: 'appealStateName',
            width: '10%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        // {
        //     title: '处罚类型',
        //     dataIndex: 'punishmentType',
        //     key: 'punishmentType',
        //     width: '10%',
        //     align: 'center',
        //     onCell: tooltipStyle,
        //     render: tooltip
        // },
        {
            title: '处罚原因',
            dataIndex: 'punishmentType',
            key: 'punishmentType',
            width: '10%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '处罚方式',
            dataIndex: 'punishmentWay',
            key: 'punishmentWay',
            width: '10%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '创建时间',
            dataIndex: 'gmtCreate',
            key: 'gmtCreate',
            width: '10%',
            align: 'center',
            onCell: tooltipStyle,
            render: text => text ? tooltip(moment(text).format('YYYY-MM-DD HH:mm:ss')) : ''
        },
        {
            title: '操作',
            dataIndex: 'key',
            key: 'key',
            align: 'center',
            // width: '10%',
            render: (text, record) => this._renderActionCell(record.id, record)
        }
    ]);

    _takeDataSource = (dataList) => {
        if (dataList) {
            return dataList;
        } else {
            return [];
        }
    }
    _renderTextMoneyCell = (text) => {
        return (
            <div style={{ wordWrap: 'break-word', wordBreak: 'break-all' }}>
                {regFenToYuan(text)}
            </div>
        );
    }
    _renderTextCell = (text) => {
        return (
            <div style={{ wordWrap: 'break-word', wordBreak: 'break-all' }}>
                {text}
            </div>
        );
    };

    _renderActionCell = (key, record) => {
        const { tableAction } = this.props;
        return (
            <div className={styles.action}>
                {/* <div className={styles.item} onClick={() => tableAction(key, 'info', record)}>详情</div> */}
                {/* 申诉待处理 */}
                <ButtonPerssion code='aftersale/deliveryticket/dispose'>
                    {record.punishmentState == 'COMPLAINING' && <div className={styles.item} onClick={() => tableAction(key, 'deal', record)}>处理</div>}
                </ButtonPerssion>
            </div>
        );
    }

    // 表格复选输入
    _rowSelection = {
        onChange: (selectedRowKeys, selectedRows) => {
            console.log(selectedRows);
        }
    };

    render() {
        const { paginationChange } = this.props;
        const { pageNum, pageSize, resultTotal, dataList } = this.props.renderData;
        return (
            <div className={styles.tableContainer}>
                <Table
                    rowClassName={(record, index) => index % 2 === 0 ? '' : styles.tdcolor}
                    // rowSelection={this._rowSelection}
                    rowKey={record => record.id}
                    columns={this._takeColumns()}
                    dataSource={this._takeDataSource(dataList)}
                    pagination={false}
                    scroll={{ y: true }}
                />
                <XPagination
                    resultTotal={resultTotal}
                    pageSize={pageSize}
                    pageNum={pageNum}
                    onChange={paginationChange}
                />
            </div>
        );
    }
}

OrderTable.propTypes = {
    renderData: PropTypes.object.isRequired, // 表格数据源
    tableAction: PropTypes.func.isRequired, // 表格操作
    paginationChange: PropTypes.func.isRequired, // 分页操作
};
export default OrderTable;